module.exports = __webpack_public_path__ + "img/logo_m.7bb8298b.png";